const cities = [
  { name: "Port St. Lucie", zips: "34952, 34953, 34983, 34984, 34986, 34987" },
  { name: "Fort Pierce", zips: "34945, 34946, 34947, 34950" },
  { name: "Jensen Beach", zips: "34957" },
  { name: "Palm City", zips: "34990, 34991" },
  { name: "Stuart", zips: "34994, 34995, 34996, 34997" },
  { name: "Hobe Sound", zips: "33455" },
  { name: "Vero Beach", zips: "32960, 32963" },
  { name: "Okeechobee", zips: "34972, 34973, 34974" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function PortStLucieLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Port St. Lucie &amp; the Treasure Coast
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Port St. Lucie, Fort Pierce, Jensen Beach, or anywhere on the Treasure Coast, Fast Passport Center makes expedited passport processing simple — no drive to West Palm Beach, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Port St. Lucie is the largest and fastest-growing city on Florida's Treasure Coast, home to roughly 200,000 residents spread across master-planned communities, golf course neighborhoods, and quiet suburban enclaves. Unlike South Florida's dense coastal cities, Port St. Lucie was designed as a suburban retreat — wide streets, abundant green space, and an intentional absence of high-rise density. The city is anchored by PGA Village, one of the most recognized golf resort communities in the United States, which draws retirees, seasonal residents, and golf enthusiasts from across the country and abroad.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What distinguishes Port St. Lucie from other Florida communities is its blend of family-oriented suburban life and active adult retirement culture. The city has a relatively young median age compared to traditional retirement communities, driven by families attracted to affordable housing, strong schools, and proximity to both the Atlantic Ocean and the Indian River Lagoon. At the same time, PGA Village and the surrounding communities host a significant population of active retirees who golf year-round, travel seasonally, and participate in organized community travel — cruises, resort vacations, and golf trips to Scotland, Ireland, and Canada.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The local economy is anchored by Cleveland Clinic Tradition (formerly Martin Health System), St. Lucie Medical Center, and a growing medical corridor that draws healthcare professionals who travel for conferences and continuing education. The New York Mets conduct spring training at Clover Park, bringing baseball fans, sports media, and seasonal hospitality workers to the area every February and March. This creates a predictable seasonal travel surge each spring — and a corresponding spike in passport renewal and expedited processing requests.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Port St. Lucie's travel demographics split into several distinct groups. Golfers and active retirees travel to Scotland, Ireland, and Canada for golf trips, often through organized PGA Village travel programs. Families travel to the Caribbean for spring break and summer vacations, typically by cruise from Port Canaveral or Fort Lauderdale. Healthcare professionals attend medical conferences in Europe, Canada, and Latin America. Baseball fans and seasonal workers travel domestically and internationally during spring training season. And snowbirds who maintain Port St. Lucie residences often discover passport issues when transitioning between their northern homes and international travel plans.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The geographic reality of Port St. Lucie matters for passport services. Located roughly 40 miles north of Palm Beach International Airport (PBI), 90 minutes south of Orlando International (MCO), and 40 minutes north of the Treasure Coast's Stuart regional hub, Port St. Lucie is not close to any regional passport agency. The closest agency is in Miami, approximately 120 miles south on I-95 — a drive of two to three hours in South Florida traffic. For a family discovering an expired child's passport two weeks before a Caribbean cruise, or a golfer preparing for a Scotland trip booked through PGA Village, that distance is not just inconvenient — it is prohibitive.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for Port St. Lucie travelers across every demographic — golfers, retirees, families, healthcare workers, and seasonal residents. Our courier-based expedited service means you start online from your PGA Village home, your Tradition neighborhood, or your Fort Pierce office — and your passport arrives within days, not months. No drive to Miami. No agency appointment roulette. Just reliable, predictable processing for Treasure Coast travelers who need their documents on time.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Port St. Lucie</p>
                  <p className="text-white/60 text-xs mt-0.5">1660 St Lucie W Blvd, Port St. Lucie, FL 34986</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Local office — serving Port St. Lucie, the Treasure Coast & surrounding communities
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout St. Lucie, Martin & Indian River Counties</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Port St. Lucie office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in St. Lucie, Martin, and northern Palm Beach Counties — start online, ship overnight, and we handle the rest. No need to drive to West Palm Beach or Miami.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Melbourne", href: "/melbourne" },
                  { name: "Stuart", href: "/stuart" },
                  { name: "Jupiter", href: "/jupiter" },
                  { name: "Palm Beach Gardens", href: "/palm-beach-gardens" },
                  { name: "West Palm Beach", href: "/west-palm-beach" },
                  { name: "Wellington", href: "/wellington" },
                  { name: "Jensen Beach", href: "/jensen-beach" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}